import type { RouteObject } from 'react-router-dom';
import type { TenantModuleConfig } from './routeTypes.js';
import { campaignsRoutes } from '../features/campaigns/routes.js';

export const moduleRegistry = [
  {
    id: 'campaigns',
    name: 'Campaigns',
    path: 'campaigns',
    permissions: ['campaign.read', 'campaign.manage'],
    menu: { label: 'Campaigns', path: 'campaigns', order: 10 },
    getRoutes: () => [campaignsRoutes],
  },
  {
    id: 'creators',
    name: 'Creators',
    path: 'creators',
    permissions: ['creator.read'],
    menu: { label: 'Creators', path: 'creators', order: 20 },
    getRoutes: () => [],
  },
  {
    id: 'finance',
    name: 'Finance',
    path: 'finance',
    permissions: ['finance.read'],
    menu: { label: 'Finance', path: 'finance', order: 30 },
    getRoutes: () => [],
  },
  {
    id: 'content',
    name: 'Content',
    path: 'content',
    permissions: ['content.read'],
    menu: { label: 'Content', path: 'content', order: 40 },
    getRoutes: () => [],
  },
] satisfies readonly TenantModuleConfig[];

export function moduleRoutes(): RouteObject[] {
  return moduleRegistry.flatMap((module) => module.getRoutes());
}
